






























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Image } from '@/types'

@Component
export default class Gallery extends Vue {
  @Prop() private images!: Image[]
  @Prop() private index!: number | null

  private visible: boolean = false
  private currentIndex: number = 0
  private showNav: boolean = false
  private isMobile: boolean = false
  private touchStartX: number = 0

  // 灯箱图片按视口选尺寸，和 srcset 声明保持一致
  private readonly gallerySizes: string = '(max-width: 768px) 90vw, 80vw'

  get currentImage(): Image {
    return this.images[this.currentIndex] || { url: '', desc: '' }
  }

  get canPrev(): boolean {
    return this.currentIndex > 0
  }

  get canNext(): boolean {
    return this.currentIndex < this.images.length - 1
  }

  @Watch('index')
  onIndexChange(newIndex: number | null) {
    if (newIndex !== null) {
      this.currentIndex = newIndex
      this.visible = true
      this.lockScroll()
      this.$nextTick(() => {
        this.preloadAdjacentImages()
      })
    } else {
      this.visible = false
      this.unlockScroll()
    }
  }

  @Watch('currentIndex')
  onCurrentIndexChange() {
    this.preloadAdjacentImages()
  }

  preloadImage(image: Image) {
    const img = new Image()
    if (image.webpSrcSet) {
      img.srcset = image.webpSrcSet
      img.sizes = this.gallerySizes
    }
    img.src = image.url
  }

  preloadAdjacentImages() {
    const prevIndex = this.currentIndex - 1
    const nextIndex = this.currentIndex + 1

    if (prevIndex >= 0) {
      this.preloadImage(this.images[prevIndex])
    }
    if (nextIndex < this.images.length) {
      this.preloadImage(this.images[nextIndex])
    }
  }

  onTouchStart(e: TouchEvent) {
    this.touchStartX = e.changedTouches[0].clientX
  }

  onTouchEnd(e: TouchEvent) {
    const delta = e.changedTouches[0].clientX - this.touchStartX
    if (Math.abs(delta) < 50) {
      return
    }
    if (delta > 0) {
      this.prev()
    } else {
      this.next()
    }
  }

  lockScroll() {
    document.body.style.overflow = 'hidden'
  }

  unlockScroll() {
    document.body.style.overflow = ''
  }

  prev() {
    if (this.canPrev) {
      this.currentIndex--
    }
  }

  next() {
    if (this.canNext) {
      this.currentIndex++
    }
  }

  handleClose() {
    this.$emit('close')
  }

  handleKeydown(e: KeyboardEvent) {
    if (!this.visible) return

    switch (e.key) {
      case 'ArrowLeft':
        this.prev()
        break
      case 'ArrowRight':
        this.next()
        break
      case 'Escape':
        this.handleClose()
        break
    }
  }

  checkMobile() {
    this.isMobile = window.innerWidth <= 768
  }

  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
    window.removeEventListener('resize', this.checkMobile)
    this.unlockScroll()
  }
}
